import { useNavigate } from "react-router-dom";
import "./Profile.scss";
import { Formik, Field } from "formik";
import Avatar from "@mui/material/Avatar";
import img from "../../../../../Assets/Login/loginBanner.png";
import ChangePassword from "../ChangePassword/ChangePassword";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { toast } from "react-toastify";
import { API_RESPONSE, I18_TRANSLATION_COMMON, NUMBER_CONSTANTS, STORAGE_KEYS, TOASTER_CONFIGS } from "../../../../Utilities/Constants/Constants";
import * as yup from "yup";
import {
  ERROR_MESSAGES,
  REGEX,
} from "../../../../Utilities/Constants/Validations";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import BasicInformation from "../../../Authentication/Registration/BasicInformation/BasicInformation";
import { Box, Card, Tab, Tabs } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PersonalInformation from "../../../Authentication/Registration/PersonalInformation/PersonalInformation";
import ProfessionalDetails from "../../../Authentication/Registration/ProfessionalDetails/ProfessionalDetails";
import BankingInformation from "../../../Authentication/Registration/BankingInformation/BankingInformation";
import Carousel from 'react-material-ui-carousel';
import carousalImage from "../../../../../Assets/global/carousal_example.svg"
import CoverImageDialog from "../CoverImageDialog/CoverImageDialog";
import { GetSessionStorageData } from "../../../../Services/Helpers/Helper";

const Profile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [currentIndex, setCurrentIndex] = useState(NUMBER_CONSTANTS.ZERO);
  const [dialogOpen, setDialogOpen] = useState<any>(API_RESPONSE.FALSE);
  const [coverData, setCoverData] = useState<any>({});
  const [IntroVideo, setIntroVideo] = useState<any>('');

  /* Getting admin detail on initialize */
  useEffect(() => {
    getCoverData();
    setIntroVideo("")
  }, []);

  /* Get cover image data */
  const getCoverData = () => {
    axiosInstance.get(API_END_POINTS.COVER_IMAGE).then((response) => {
      setCoverData(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
    });
    if (GetSessionStorageData(STORAGE_KEYS.ROLE) == NUMBER_CONSTANTS.FOUR) {
      axiosInstance.get(API_END_POINTS.GET_SPDETAILS).then((response) => {
        setIntroVideo(response?.data?.result?.data[NUMBER_CONSTANTS.ZERO])
      });
    }
  }

  /* Open/close cover image dialog */
  const onCoverImageDialogClose = () => {
    setDialogOpen(API_RESPONSE.FALSE);
    getCoverData();
  };

  return (
    <div className="profile_container">
      <CoverImageDialog
        open={dialogOpen}
        handleClose={onCoverImageDialogClose}
        detail={coverData}
      />
      <div className="carousal-wrapper">
        {GetSessionStorageData(STORAGE_KEYS.ROLE) == NUMBER_CONSTANTS.FOUR && coverData?.cover_images?.length > 0 && coverData?.intro_video ? (
          <Carousel>
            {coverData?.cover_images?.length > 0 && coverData?.cover_images?.map((item: any, index: any) => (
              <img src={item} key={index} className="carousal-image" />
            ))}
            {coverData?.intro_video && (
              <video controls width="100%" height="200" autoPlay>
                <source src={coverData?.intro_video} type="video/mp4" />
              </video>
            )}
          </Carousel>
        ) : (
          <Carousel>
            {coverData?.cover_images?.length > 0 && coverData?.cover_images?.map((item: any, index: any) => (
              <img src={item} key={index} className="carousal-image" />
            ))}
          </Carousel>
        )}


        <div className="profile-wrapper">
          <img className="menu-profile-img" alt="profile" src={coverData?.profile} />
        </div>
        <div className="change-btn">
          <button className="btn btn-primary" onClick={() => setDialogOpen(API_RESPONSE.TRUE)}>Edit cover</button>
        </div>
      </div>

      <div className="menu-tabs-wrapper">
        <Box sx={{ bgcolor: "background.paper" }}>
          <Tabs
            value={currentIndex}
            onChange={(e: any, value: number) => {
              setCurrentIndex(value);
            }}
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab className="tab-text" value={NUMBER_CONSTANTS.ZERO} label={<div className="menu-label"><InfoIcon className="menu-icon" /> Basic Information</div>} />
            <Tab className="tab-text" value={NUMBER_CONSTANTS.ONE} label={<div className="menu-label"><PersonIcon className="menu-icon" /> Personal Information</div>} />
            <Tab className="tab-text" value={NUMBER_CONSTANTS.TWO} label={<div className="menu-label"><WorkIcon className="menu-icon" /> Professional Information</div>} />
            <Tab className="tab-text" value={NUMBER_CONSTANTS.THREE} label={<div className="menu-label"><AccountBalanceIcon className="menu-icon" /> Banking Information</div>} />
          </Tabs>
        </Box>
      </div>
      <div className="row">
        <div className="col-md-12">
          {currentIndex === NUMBER_CONSTANTS.ZERO && <BasicInformation />}
          {currentIndex === NUMBER_CONSTANTS.ONE && <PersonalInformation />}
          {currentIndex === NUMBER_CONSTANTS.TWO && <ProfessionalDetails />}
          {currentIndex === NUMBER_CONSTANTS.THREE && <BankingInformation />}
        </div>
      </div>

    </div>
  );
};

export default Profile;
